/* eslint-disable fht-eslint-rules/string-literal-validator */
import assert from "assert";
import { CmsPresetPageEnum } from "./apis/model/CmsPresetPageEnum";
import { IS_DEV } from "./consts";
import { CMS_PROXY_URL, fhtGlobalEnv } from "./env";
import { qadd } from "./url_helpers";

// eslint-disable-next-line compat/compat
const companyHost = IS_DEV ? CMS_PROXY_URL : fhtGlobalEnv.Env.Hosts.FhtWebCompanyRoot;

interface CmsOpts {
  templateId: string;
}

export function cmsHomeUrl(companyId: number, opts?: Partial<CmsOpts>): string {
  assert(companyId, "companyId falsy");
  return qadd(companyHost + `/c${companyId}`, opts);
}

export function cmsProductsUrl(companyId: number): string {
  assert(companyId, "companyId falsy");
  return companyHost + `/c${companyId}/product`;
}

export function cmsPresetArticleUrl(companyId: number, presetPage: CmsPresetPageEnum): string {
  assert(companyId, "companyId falsy");
  return companyHost + `/c${companyId}/${presetPage}`;
}

export function cmsNewsUrl(companyId: number): string {
  assert(companyId, "companyId falsy");
  return `${companyHost}/c${companyId}/news`;
}

export function cmsAboutUsUrl(companyId: number): string {
  assert(companyId, "companyId falsy");
  return companyHost + `/c${companyId}/about.html`;
}

export function cmsContactUsUrl(companyId: number): string {
  assert(companyId, "companyId falsy");
  return companyHost + `/c${companyId}/contact.html`;
}

export function productDetailUrl(productId: number): string {
  assert(productId, "productId falsy");
  return fhtGlobalEnv.Env.Hosts.FhtWebDetailRoot + `/pro${productId}.html`;
}

export function cmsArticleDetailUrl(companyId: number, articleId: number): string {
  assert(companyId, "companyId falsy");
  assert(articleId, "articleId falsy");
  return companyHost + `/c${companyId}/n${articleId}.html`;
}

export function cmsArticleTypeUrl(companyId: number, articleTypeId: number): string {
  assert(companyId, "companyId falsy");
  assert(articleTypeId, "articleTypeId falsy");
  return companyHost + `/c${companyId}/n${articleTypeId}`;
}

export interface PreviewContext {
  companyId: number;
  templateId: string;
  cmsSettingId: number;
  previewSettingsTimeToken: string;
}

export function assertValidPreviewContext(s: PreviewContext): void {
  assert(s, "previewContext falsy");
  assert(s.companyId, "s.companyId falsy");
  assert(s.companyId > 0, "s.companyId not pos");
  assert(s.cmsSettingId, "s.cmsSettingId falsy");
  assert(s.cmsSettingId > 0, "s.cmsSettingId not pos");
  assert(typeof s.templateId === "string", "s.templateId not string");
  assert(s.previewSettingsTimeToken, "s.previewSettingsTimeToken falsy");
}

export function templateSettingUrl(previewContext: PreviewContext): string {
  assertValidPreviewContext(previewContext);
  const u = companyHost + "/Preview/TemplateSetting";
  return qadd(u, previewContext);
}

export function addOrUpdatePreviewSettingsUrl(previewContext: PreviewContext): string {
  assertValidPreviewContext(previewContext);
  const u = companyHost + "/Preview/AddOrUpdatePreviewSettings";
  return qadd(u, previewContext);
}
export function templateSettingSchemaJsonUrl(templateId: string): string {
  assert(templateId, "templateId falsy");
  const u = companyHost + `/TemplateSettingSchema/${templateId}`;
  return u;
}

export function defaultTemplateDataJsonUrl(templateId: string): string {
  assert(templateId, "templateId falsy");
  return companyHost + `/Static/DefaultTemplateDataJson?templateId=${templateId}`;
}
